import { Link, useParams } from "react-router-dom"
import DashboardSideBar from "../../components/dashboardSidebar"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import { useState, useEffect } from "react"
import services from "../../services"
import Toaster from "../../components/toaster";
import moment from 'moment'
import useIsMobile from "../../hooks/useIsMobile";
import MobileHeader from "../../components/MobileHeader";

const OneWayAvailabilityDetail = () => {
    const { id } = useParams();
    const isMobileView = useIsMobile();
    const [availabilityData, setAvailabilityData] = useState(null)
    const [toaster, setToaster] = useState({ visiblity: "hide" });
    const [loading, setLoading] = useState(true)
    const [inquiries, setInquiries] = useState([])
    const [inquiriesLoading, setInquiriesLoading] = useState(false)
    const [inquiriesPage, setInquiriesPage] = useState(1)
    const [inquiriesLimit] = useState(10)
    const [inquiriesTotalCount, setInquiriesTotalCount] = useState(0)

    const getAvailabilityDetails = async () => {
        setLoading(true)
        try {
            const response = await services.Vendor.GET_ONE_WAY_AVAILABILITY_BY_ID(id);
            setAvailabilityData(response.data)
        } catch (error) {
            console.log(error)
            setToaster({
                type: "danger",
                title: "Error Occured",
                text: error.response?.data?.message || "Failed to fetch availability details",
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({ visiblity: "hide" });
            }, 1500)
        } finally {
            setLoading(false)
        }
    }

    const getInquiries = async () => {
        setInquiriesLoading(true)
        try {
            const response = await services.Vendor.GET_INQUIRIES_BY_AVAILABILITY_ID(id, { 
                page: inquiriesPage, 
                limit: inquiriesLimit 
            });
            // Handle response structure with inquiries object containing count and rows
            if (response.data?.inquiries) {
                if (response.data.inquiries.rows) {
                    // New structure: { inquiries: { count, rows } }
                    setInquiries(response.data.inquiries.rows || [])
                    setInquiriesTotalCount(response.data.inquiries.count || 0)
                } else if (Array.isArray(response.data.inquiries)) {
                    // Fallback: if inquiries is directly an array
                    setInquiries(response.data.inquiries)
                    setInquiriesTotalCount(response.data.totalCount || response.data.inquiries.length || 0)
                } else {
                    setInquiries([])
                    setInquiriesTotalCount(0)
                }
            } else {
                setInquiries([])
                setInquiriesTotalCount(0)
            }
        } catch (error) {
            console.log(error)
            // Don't show error toast for inquiries, just log it
            setInquiries([])
            setInquiriesTotalCount(0)
        } finally {
            setInquiriesLoading(false)
        }
    }

    useEffect(() => {
        if (id) {
            getAvailabilityDetails()
        }
    }, [id])

    useEffect(() => {
        if (id) {
            getInquiries()
        }
    }, [id, inquiriesPage])

    const leadsCount = inquiriesTotalCount || inquiries.length || 0;

    if (isMobileView) {
        if (loading || !availabilityData) {
            return (<main className="mlux" style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}><div className="mlux-empty"><div className="ic"><i className="far fa-spinner"></i></div><h4>Loading…</h4></div></main>);
        }
        const a = availabilityData;
        const carName = `${a.vendorCar?.Car?.name || a.vendorCar?.car?.name || 'N/A'} (${a.vendorCar?.Car?.brand || a.vendorCar?.car?.brand || 'N/A'})`;
        return (
            <>
                <Toaster type={toaster.type} title={toaster.title} text={toaster.text} visiblity={toaster.visiblity} />
                <SideBar />
                <main className="mlux mlux-auth">
                    <MobileHeader back="/oneWayAvailabilities" right={<span className="mlux-pill" style={{ background: a.isCompleted ? 'rgba(37,99,235,0.12)' : a.isActive ? 'rgba(22,163,74,0.12)' : 'rgba(239,68,68,0.12)', color: a.isCompleted ? '#2563eb' : a.isActive ? '#16a34a' : '#ef4444' }}>{a.isCompleted ? 'Completed' : a.isActive ? 'Active' : 'Inactive'}</span>} />
                    <div className="mlux-greet" style={{ margin: '8px 4px 2px' }} data-rise="1">
                        <div className="kick">One-way availability</div>
                        <div className="nm" style={{ fontSize: 22 }}>{carName}</div>
                    </div>

                    <div className="mlux-route mlux-card" style={{ padding: '16px 16px 16px 40px' }} data-rise="1">
                        <div className="pt from"><small>From</small>{a.from?.full_address || 'N/A'}</div>
                        <div className="pt to"><small>To</small>{a.to?.full_address || 'N/A'}</div>
                    </div>

                    <div className="mlux-sec-head"><h3>Details</h3></div>
                    <div className="mlux-card" style={{ padding: '4px 16px' }} data-rise="2">
                        <div className="mlux-kv"><span className="k"><i className="far fa-calendar"></i> Trip date</span><span className="v">{moment(a.tripDate).format('DD MMM YY')}</span></div>
                        <div className="mlux-kv"><span className="k"><i className="far fa-id-card"></i> RC number</span><span className="v">{a.vendorCar?.rcNumber || 'N/A'}</span></div>
                        <div className="mlux-kv"><span className="k"><i className="far fa-user-group"></i> Leads</span><span className="v" style={{ color: 'var(--accent)', fontWeight: 800 }}>{leadsCount}</span></div>
                        <div className="mlux-kv"><span className="k"><i className="far fa-phone"></i> Contact</span><span className="v">{a.contactNumber || 'N/A'}</span></div>
                        {a.alternativeContactNumber && <div className="mlux-kv"><span className="k"><i className="far fa-phone"></i> Alt. contact</span><span className="v">{a.alternativeContactNumber}</span></div>}
                    </div>

                    <div className="mlux-sec-head"><h3>Leads</h3><span style={{ color: 'var(--accent)', fontSize: 13, fontWeight: 800 }}>{leadsCount}</span></div>
                    {inquiries && inquiries.length ? inquiries.map((iq, i) => (
                        <div className="mlux-card mlux-lrow" key={i} data-rise="3">
                            <span className="lic"><i className="far fa-user"></i></span>
                            <div className="lmain">
                                <div className="lt">{iq.customerName || iq.name || iq.User?.firstName || 'Customer'}</div>
                                <div className="ls">{iq.contactNumber || iq.phoneNumber || iq.User?.phoneNumber || ''}{iq.createdAt ? ` · ${moment(iq.createdAt).format('DD MMM')}` : ''}</div>
                            </div>
                        </div>
                    )) : (
                        <div className="mlux-card mlux-empty" data-rise="3"><div className="ic"><i className="far fa-comment-dots"></i></div><h4>No leads yet</h4><p>Rider leads for this trip will show here.</p></div>
                    )}

                    {!a.isCompleted && <Link to={`/oneWayAvailabilities/edit/${a.id}`} className="mlux-btn" style={{ marginTop: 16, textDecoration: 'none' }}><i className="far fa-pen"></i> Edit availability</Link>}
                </main>
            </>
        );
    }

    if (loading) {
        return (<>
            <Header />
            <SideBar />
            <main class="main">
                <div class="user-profile py-5">
                    <div class="container">
                        <div class="row">
                            <DashboardSideBar />
                            <div class="col-lg-9">
                                <div class="text-center py-5">
                                    <p>Loading availability details...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </>)
    }

    if (!availabilityData) {
        return (<>
            <Header />
            <SideBar />
            <main class="main">
                <div class="user-profile py-5">
                    <div class="container">
                        <div class="row">
                            <DashboardSideBar />
                            <div class="col-lg-9">
                                <div class="text-center py-5">
                                    <p>Availability not found</p>
                                    <Link to={'/oneWayAvailabilities'} class="theme-btn">Back to Availabilities</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </>)
    }

    return (<>
        <Header />
        <SideBar />
        <main class="main">
            <Toaster
                type={toaster.type}
                title={toaster.title}
                text={toaster.text}
                visiblity={toaster.visiblity}
            />

            <div class="user-profile py-5">
                <div class="container">
                    <div class="row">
                        <DashboardSideBar />
                        <div class="col-lg-9">
                            <div class="user-profile-wrapper">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="user-profile-card">
                                            <div class="user-profile-card-header">
                                                <h4 class="user-profile-card-title">One-Way Availability Details</h4>
                                                <div class="user-profile-card-header-right">
                                                    {!availabilityData.isCompleted && <Link to={`/oneWayAvailabilities/edit/${id}`} class="theme-btn">
                                                        <i class="far fa-pencil"></i> Edit
                                                    </Link>}
                                                </div>
                                            </div>
                                            <div class="user-profile-form">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Car</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={`${availabilityData.vendorCar?.Car?.name || availabilityData.vendorCar?.car?.name || 'N/A'} (${availabilityData.vendorCar?.Car?.brand || availabilityData.vendorCar?.car?.brand || 'N/A'}) - ${availabilityData.vendorCar?.rcNumber || 'N/A'}`}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Trip Date</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={moment(availabilityData.tripDate).format('DD-MM-YYYY')}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Leads</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={leadsCount}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>From Location</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={availabilityData.from?.full_address || 'N/A'}
                                                                disabled
                                                            />
                                                            {availabilityData.from?.longitude && availabilityData.from?.latitude && (
                                                                <small className="text-muted">
                                                                    Coordinates: {availabilityData.from.latitude}, {availabilityData.from.longitude}
                                                                </small>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>To Location</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={availabilityData.to?.full_address || 'N/A'}
                                                                disabled
                                                            />
                                                            {availabilityData.to?.longitude && availabilityData.to?.latitude && (
                                                                <small className="text-muted">
                                                                    Coordinates: {availabilityData.to.latitude}, {availabilityData.to.longitude}
                                                                </small>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Contact Number</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={availabilityData.contactNumber || 'N/A'}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Alternative Contact Number</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={availabilityData.alternativeContactNumber || 'N/A'}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Status</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={availabilityData.status ? 'Active' : 'Inactive'}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Is Active</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={availabilityData.isCompleted ? 'Completed' : availabilityData.isActive ? 'Active' : 'Inactive'}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Created Date</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={moment(availabilityData.createdAt).format('DD-MM-YYYY, hh:mm A')}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Updated Date</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={moment(availabilityData.updatedAt).format('DD-MM-YYYY, hh:mm A')}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center gap-3">
                                                    <Link to={'/oneWayAvailabilities'} class="theme-btn my-3" style={{ background: '#6c757d' }}>
                                                        <span class="far fa-arrow-left"></span> Back to List
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                {/* Inquiries Section */}
                                <div class="row mt-4">
                                    <div class="col-lg-12">
                                        <div class="user-profile-card">
                                            <div class="user-profile-card-header">
                                                <h4 class="user-profile-card-title">
                                                    Leads ({leadsCount})
                                                </h4>
                                            </div>
                                            {inquiriesLoading ? (
                                                <div class="text-center py-5">
                                                    <p>Loading leads...</p>
                                                </div>
                                            ) : (
                                                <>
                                                    {inquiries && inquiries.length > 0 ? (
                                                        <>
                                                            <div class="table-responsive">
                                                                <table class="table text-nowrap">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>User Name</th>
                                                                            <th>Contact Number</th>
                                                                            <th>Status</th>
                                                                            <th>Inquiry Date</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {inquiries.map((inquiry, index) => (
                                                                            <tr key={inquiry.id || index}>
                                                                                <td>
                                                                                    <span>{inquiry.userName || 'N/A'}</span>
                                                                                </td>
                                                                                <td>
                                                                                    <span>{inquiry.contactNumber || 'N/A'}</span>
                                                                                </td>
                                                                                <td>
                                                                                    <span class={`badge badge-${inquiry.status ? 'success' : 'danger'}`}>
                                                                                        {inquiry.status ? 'Active' : 'Inactive'}
                                                                                    </span>
                                                                                </td>
                                                                                <td>
                                                                                    <span>{moment(inquiry.createdAt).format('DD-MM-YYYY, hh:mm A')}</span>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            {Math.ceil(inquiriesTotalCount / inquiriesLimit) > 1 && (
                                                                <div class="d-flex justify-content-between align-items-center mt-3 px-3 pb-3">
                                                                    <button
                                                                        class="btn btn-outline-secondary"
                                                                        onClick={() => setInquiriesPage(prev => Math.max(1, prev - 1))}
                                                                        disabled={inquiriesPage === 1}
                                                                    >
                                                                        Previous
                                                                    </button>
                                                                    <span>Page {inquiriesPage} of {Math.ceil(inquiriesTotalCount / inquiriesLimit)}</span>
                                                                    <button
                                                                        class="btn btn-outline-secondary"
                                                                        onClick={() => setInquiriesPage(prev => Math.min(Math.ceil(inquiriesTotalCount / inquiriesLimit), prev + 1))}
                                                                        disabled={inquiriesPage >= Math.ceil(inquiriesTotalCount / inquiriesLimit)}
                                                                    >
                                                                        Next
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <div class="text-center py-5">
                                                            <p>No leads yet.</p>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </main>
        <Footer />
    </>
    )
}
export default OneWayAvailabilityDetail

